import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';
import { Button, Card, CardContent, CircularProgress, Container, CssBaseline, Grid, Pagination, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import FirstElement from '../../components/first-element';
import Footer from '../../components/footer';
import HeaderMenu from '../../components/header-menu';
import CustomizedSnackbars from '../../components/material-snackbars';
import CustomMyMaterialTable from 'src/components/table/custom-my-material-table';
import { AbilityContext } from '../../config/ability-context';
import * as componentActions from '../../redux/actions/params';
import * as ParamsService from "../../services/2talk/chatbotResponseParams.service.js";
import Api from '../../services/api';
import { Overlay } from '../../styles/global';
import { Styles } from '../../styles/material-styles';

class ParamsList extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;
        this.emptyArray = true;

        this.state = {
            dataFilter: false,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
            totalPages:0,
            page:1,
            pageStart:0,
            pageEnd:0,
            count:0,
            searchValue: ''
        };

        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    onChangePaginate = (e,page) =>{
        this.setState({ page:page });
        this.getItens(page);
    }

    setPagination(count,page){              
        let totalPage = Math.ceil (count/10);
        this.setState({ totalPages:totalPage })
        if(count > 0){
            if(page == 1){
                this.setState({pageStart:1,pageEnd:10});
            } else{
                let pageStart = ((page - 1) * 10) + 1;
                if(count >= page * 10){
                    this.setState({pageStart:pageStart,pageEnd:page * 10});
                } else{
                    this.setState({pageStart:pageStart,pageEnd:count});
                }
            }
        } else {
            this.setState({totalPages:0,page:1,count:0});
        }                   
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.location.state === "reload"){
            this.componentDidMount();
        }
    }    

    componentDidMount() {
      this.getItens();
    }

    fetchDataNotSuccess(result) {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
    }

    fetchDataThrowError(err) {
        const intl = this.props.intl;
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
    }

    async getItens(page = 1) {
        this.setState({ loading: true });

        try {
            const output = await ParamsService.getAllPaginate(page);
      
            if (output.success) {
                this.emptyArray = (output.data.length === 0) ? true : false ;
                const count = output.count;
                this.setState({count});
                this.setPagination(count, page);
                const formattedList = output.data.map(item => {
                    return {...item}
                });
                this.setState({ loading: false, resultList: formattedList });

            } else {
                this.fetchDataNotSuccess(output);
                Api.kickoff(output);
            }
      
        } catch (err) {
            this.fetchDataThrowError(err)
            Api.kickoff(err);

        } finally {
            this.setState({ loading: false });
        }
    };

    callSearch(){
        if(this.state.searchValue != '') this.getItens(this.state.page);                        
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page:1 });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    async deleteItem(data, resolve) {
        const intl = this.props.intl;

      try {
        const output = await ParamsService.deleteById(data.id);

        if (output.success) {
          if(output.data.success != null && output.data.success == false) {
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: output.data.content && output.data.content ? output.data.content : 'Error ao excluir o registro'
            });
            
            resolve();
            return;
          }

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: intl.formatMessage({id:"delete.sucess"}),
            resultList: []
          });

          await this.getItens();
          } else {
            this.fetchDataNotSuccess(output);
            Api.kickoff(output);
          }

          resolve();
      } catch (err) {
        resolve();
        this.fetchDataThrowError(err);
        Api.kickoff(err);
      } 
    };

    clearFields(){
        this.setState({searchValue: '', page:1, loading: true})
        this.getItens(1);
    }

    render() {

        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;

        if (Api == null) {
            var lang = this.props.match.params.lang;
            document.location.href = `/${lang}/unavailable`
        }

        return (
          <div className={classes.root} style={{paddingLeft:0, marginLeft:0}}>
            <HeaderMenu />
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: headerMenu.open,
                }, classes.actionsContent, {
                    [classes.actionscontentShift]: actionsHeaderMenu.open,
                })}
            >
                <div className={classes.drawerHeader} />
                <Container component='main' maxWidth='false' style={{paddingLeft:0, marginLeft:0}}>
                    
                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}
                    
                    {(!this.emptyArray || this.state.dataFilter) ? (
                        <div>
                            <CssBaseline />
                            <Grid container className={classes.mb20}  spacing={0}>             
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    size='large'
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    disabled={!this.context.can('Add', 'Group')}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/params-registration` }}
                                >
                                    {<FormattedMessage id="add" />}
                                </Button>
                            </Grid>

                            <Grid container spacing={6} alignItems="center"> 
                                <Grid item xs={12} sm={12}>
                                    <Card className="background-title-search">
                                        <CardContent> 
                                            <Grid container spacing={1} alignItems="center">
                                                
                                                <Grid item xs={12} sm={5} md={3} lg={6}>
                                                    <Typography variant="h5">
                                                        {<FormattedMessage id="params.header" />}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>                                
                            </Grid>  

                            <CustomMyMaterialTable
                                title=""
                                rowClick={(event, rowData) => {  
                                    this.props.addCurrent(rowData);
                                    this.props.history.push(`/${this.props.match.params.lang}/params-edit`);
                                }}
                                columns={[
                                    { 
                                        title: intl.formatMessage({id:"id"}), 
                                        field: 'id'
                                    },
                                    { 
                                        title: intl.formatMessage({id:"name"}), 
                                        field: 'name'
                                    },
                                    { 
                                        title: "", 
                                        field: ""
                                    },
                                    { 
                                        title: "", 
                                        field: ""
                                    },
                                    { 
                                        title: "", 
                                        field: ""
                                    },
                                    { 
                                        title: "", 
                                        field: ""
                                    },
                                ]}
                                data={this.state.resultList}
                                deleteItem={this.deleteItem}
                                conditionDisabledDelete={(rowData) => !ParamsService.checkParamIsSystem(rowData)}
                            />

                            <Grid container style={{marginBottom:12,marginTop:8}}>
                                <Grid item xs={12} md={3}>
                                    <Pagination  count={this.state.totalPages} page={this.state.page}  onChange={this.onChangePaginate} />
                                </Grid>
                                <Grid item xs={12} sm={3} style={{marginTop:6}}>
                                    {this.state.pageStart} &nbsp;
                                    {<FormattedMessage id="to" />} &nbsp; 
                                    {this.state.pageEnd} &nbsp;
                                    {<FormattedMessage id="of" />} &nbsp; 
                                    {this.state.count} &nbsp;
                                    {<FormattedMessage id="register" />}
                                </Grid>
                            </Grid>
        
                        </div>)
                    :(
                        <div>
                            <FirstElement
                                title = {intl.formatMessage({id:"params.list.create.first.params"})}
                                subtitle = {intl.formatMessage({id:"params.list.create.params"})}
                                buttonText = {
                                    <Button
                                    variant='contained'
                                    color='secondary'
                                    size='large'
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/params-registration` 
                                }}>
                                {<FormattedMessage id="add" />}
                                </Button>
                                }
                                icon = {<AccountTreeIcon style={{fontSize: "45px"}} />}
                            />
                        </div>
                    )}

                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}

                    <CustomizedSnackbars
                        variant={this.state.notificationVariant}
                        message={this.state.notificationMessage}
                        isOpen={this.state.openNotification}
                        toClose={this.closeNotification}
                    />
                </Container>
            </main>
            <Footer />   
        </div>
        );
    }
}

ParamsList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ParamsList)));

ParamsList.contextType = AbilityContext;